module.exports = __webpack_public_path__ + "media/images/favicons/48px-2a6fff5868113c54595410abfd08b07b.png";